import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  TeamManagementUsersQuery,
  TeamManagementUsersRequest,
} from "lib/generated/app-service-gql/graphql";
import { useCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const teamManagementUsersQuery = graphql(`
  query teamManagementUsers($request: TeamManagementUsersRequest!) {
    teamManagementUsers(request: $request) {
      total
      results {
        guid
        firstName
        lastName
        email
        createdAt
        companyAdmin
        stotlesAdmin
        paymentType
        lastAccessedAt
        team {
          id
          name
        }
      }
    }
  }
`);

export type TeamManagementUser = TeamManagementUsersQuery["teamManagementUsers"]["results"][number];

export function useUserManagement(
  request: TeamManagementUsersRequest,
  options?: UseQueryOptions<TeamManagementUsersQuery, unknown, TeamManagementUsersQuery, QueryKey>,
) {
  const { data: currentUser } = useCurrentUser();

  const { data, ...rest } = useGraphQlQuery(
    ["team_management_users", currentUser?.guid, request],
    teamManagementUsersQuery,
    [{ request }],
    { ...REACT_QUERY_OPTIONS_NEVER_REFETCH, ...options },
  );

  return { data: data?.teamManagementUsers, ...rest };
}
